import { render, staticRenderFns } from "./schoolPart.vue?vue&type=template&id=e8f13364&scoped=true"
import script from "./schoolPart.vue?vue&type=script&lang=js"
export * from "./schoolPart.vue?vue&type=script&lang=js"
import style0 from "./schoolPart.vue?vue&type=style&index=0&id=e8f13364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f13364",
  null
  
)

export default component.exports